import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import React, { use, useEffect, useState } from "react";


export const UpdatePassword = ({ passwordData, setPasswordData, handleUpdateMyPassword }) => {
    const [error, setError] = useState("");
    useEffect(() => {
        validatePasswords();
    }, [passwordData.new_password, passwordData.confirm_new_password]);
    const validatePasswords = () => {
        if (passwordData.new_password !== passwordData.confirm_new_password) {
            setError("New password and confirmation do not match.");
            return false;
        }
        if (passwordData.new_password.length < 8) {
            setError("New password must be at least 8 characters long.");
            return false;
        }
        setError("");
        return true;
    };
  return (
    <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-2xl font-bold text-[#1A3C34] mb-6">Update Password</h2>
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <Label className="text-sm font-medium text-gray-700 mb-1 block">Current Password</Label>
              <Input 
                type="password" 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3C34]"
                placeholder="Current Password"
                value={passwordData.old_password}
                onChange={(e) => setPasswordData({ ...passwordData, old_password: e.target.value })}
              />
              
            </div>
            <div>
              <Label className="text-sm font-medium text-gray-700 mb-1 block">New Password</Label>
              <Input 
                type="password" 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3C34]"
                placeholder="New Password"
                value={passwordData.new_password}
                onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <Label className="text-sm font-medium text-gray-700 mb-1 block">Confirm New Password</Label>
              <Input 
                type="password" 
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3C34]"
                placeholder="Confirm New Password"
                value={passwordData.confirm_new_password}
                onChange={(e) => setPasswordData({ ...passwordData, confirm_new_password: e.target.value })}
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>
          </div>

          <Button
            data-testid="submit-password-change"
            className="w-full bg-[#1A3C34] hover:bg-[#142E28] text-white rounded-full py-6"
            onClick={handleUpdateMyPassword}
          >
            Update Password
          </Button>
        </div>
     </div>       
  );
};
